// eslint-disable-next-line import/prefer-default-export
export const GMAP_API_KEY = 'AIzaSyANiO1eVbjONESEm3InY16VbQQGmO2qsp4';
